module.exports = __webpack_public_path__ + "staticfr/media/marcas (2).bce9e703.jpg";